import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import '../common/css/FilterAccordion.css';

interface FilterAccordionProps {
    title: string;
    icon?: string;
    activeCount?: number;
    onClear?: () => void;
    clearLabel?: string;
    defaultOpen?: boolean;
    open?: boolean;
    onToggle?: (open: boolean) => void;
    footer?: React.ReactNode;
    children: React.ReactNode;
}

const FilterAccordion: React.FC<FilterAccordionProps> = ({ title, icon = 'bi-filter', activeCount = 0, onClear, clearLabel = 'Clear All', defaultOpen = false, open, onToggle, footer, children, }) => {
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    const isControlled = open !== undefined;
    const isOpen = isControlled ? open : internalOpen;

    const handleToggle = () => {
        const next = !isOpen;
        isControlled ? onToggle?.(next) : setInternalOpen(next);
    };

    return (
        <div className="filter-accordion border rounded-3 bg-white flex-shrink-0">
            <div
                className="filter-accordion__header d-flex align-items-center justify-content-between px-4 py-3"
                onClick={handleToggle}
                role="button"
                aria-expanded={isOpen}
            >
                <div className="d-flex align-items-center gap-2">
                    <i className="ki-duotone ki-filter fs-4 text-gray-600">
                        <span className="path1" />
                        <span className="path2" />
                    </i>
                    <span className="fw-semibold filter-accordion__title">{title}</span>
                    {activeCount > 0 && (
                        <span className="badge rounded-pill filter-accordion__badge">
                            {activeCount}
                        </span>
                    )}
                </div>

                <div className="d-flex align-items-center gap-3">
                    { onClear && (
                        <span
                            className="filter-accordion__clear small fw-medium"
                            onClick={(e) => {
                                e.stopPropagation();
                                onClear();
                            }}
                        >
                            {clearLabel}
                        </span>
                    )}
                    {footer && (
                        <div
                            className="d-flex align-items-center gap-2"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {footer}
                        </div>
                    )}
                    <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'} text-secondary`} />
                </div>
            </div>

            <Collapse in={isOpen}>
                <div>
                    <div className="filter-accordion__body border-top px-4 py-3">
                        {children}
                    </div>

                    {/* {footer && (
                        <div className="filter-accordion__footer border-top px-4 py-3 d-flex justify-content-end gap-2">
                            {footer}
                        </div>
                    )} */}
                </div>
            </Collapse>
        </div>
    );
};

export default FilterAccordion;